import { Color, Flex, Radio, RadioGroupProps } from '@bb/elements-web';
import { Icon } from 'components';
import React from 'react';
import styled from 'styled-components';

export type RecipientsSearchTabsProps = Pick<
  RadioGroupProps,
  'onChange' | 'value'
>;

const options = [
  { label: 'Branches', value: 'locations' },
  { label: 'Teams', value: 'teams' },
  { label: 'Groups', value: 'groups' },
  { label: 'Users', value: 'users' },
];

export const RecipientsSearchTabs: React.FC<RecipientsSearchTabsProps> = ({
  onChange,
  value = 'locations',
}) => (
  <StyledFlex align="center" gap={8} wrap="nowrap">
    <StyledIconContainer justify="center" align="center">
      <Icon type="antdSearchOutlined" />
    </StyledIconContainer>
    <StyledRadioGroup
      dataCy="recipients-search-tabs"
      onChange={onChange}
      value={value}
      optionType="button"
      buttonStyle="solid"
      size="large"
    >
      {options.map(option => (
        <Radio.Button
          dataCy={`${option.value}-tab`}
          key={option.value}
          value={option.value}
        >
          {option.label}
        </Radio.Button>
      ))}
    </StyledRadioGroup>
  </StyledFlex>
);

const StyledFlex = styled(Flex)`
  width: 100%;
  margin-bottom: 1em;
`;

const StyledIconContainer = styled(Flex)`
  flex: 0 1.5 10%;

  @media screen and (min-width: 992px) and (max-width: 1300px) {
    display: none;
  }
`;

const StyledRadioGroup = styled(Radio.Group)`
  flex: 1 1 auto;
  white-space: nowrap;
  display: flex;
  gap: 2px;

  &&& .ant5-radio-button-wrapper {
    flex: 1 1 25%;
    text-align: center;
    border-radius: 4px;
    border: 1px solid ${Color.LIGHT_GREY};
    font-size: 1.2rem;

    &:not(:first-child)::before {
      display: none;
    }
  }
`;
